import { getPharmacySettings } from "@/core/admin/establishment-store";

export function formatMoney(value: number): string {
  const { currency } = getPharmacySettings();
  const amount = Number.isFinite(value) ? value : 0;
  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toLocaleString("fr-FR")} ${currency}`;
  }
}

/** Montants graphiques dashboard — sans décimales, devise établissement. */
export function formatMoneyCompact(value: number): string {
  const { currency } = getPharmacySettings();
  const amount = Number.isFinite(value) ? value : 0;
  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${amount.toLocaleString("fr-FR")} ${currency}`;
  }
}
export function formatInvoiceDate(iso: string): string {
  return new Date(iso).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatInvoiceDateShort(iso: string): string {
  return new Date(iso).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
